import { ChevronLeft } from "lucide-react"
import { Button, BreadcrumbWrapper, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator } from "twyne-new.ui"

import { useUtilities } from "@/modules/cms/views/post/components/builder/context"

import { UTILITIES_ALIASES } from "../predefined_sizes"

const UtilitiesBreadcrumb = () => {
  const { selectedUtilities = [], setSelectedUtilities } = useUtilities()

  const handleChangeUtilities = utilityIndex => {
    setSelectedUtilities(selectedUtilities.slice(0, utilityIndex + 1))
  }

  return <>
    <div className="px-2 text-lg flex gap-2 mt-2">
      {selectedUtilities.length > 0 && <>
        <Button variant='light' size='sm' color='accent' onClick={() => handleChangeUtilities(selectedUtilities.length - 2)}>
          <ChevronLeft size='16' className="cursor-pointer hover:text-white twy-text-base" />
        </Button>
      </>}

      <BreadcrumbWrapper>
        <BreadcrumbList>
          {selectedUtilities.map((value, index) => <>
            <BreadcrumbItem key={value} className="cursor-pointer" onClick={() => handleChangeUtilities(index)}>
              <BreadcrumbLink>{UTILITIES_ALIASES[value] || value}</BreadcrumbLink>
            </BreadcrumbItem>
            {value !== selectedUtilities[selectedUtilities.length - 1] && <BreadcrumbSeparator />}
          </>)}
        </BreadcrumbList>
      </BreadcrumbWrapper>
    </div>
  </>
}

export default UtilitiesBreadcrumb
